import { IconProps } from "./dto";

export function CloseIcon(props: IconProps) {
    return (
        <svg width={props.size ?? "18"} height={props.size ?? "18"} onClick={props.onClick} viewBox="0 0 18 18" fill="none">
            <path d="M17 1L1 17M1 1L17 17" stroke={props.color ?? "#8383AD"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}
